import React, { useEffect } from "react";
import Home from "../home/Home";
import About from "../about/About";
import Skills from "../skills/Skills";
import Works from "../home/works/Works";
import ContactMe from "../contactMe/ContactMe";
import { useLocation } from "react-router-dom";

function Main() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <main>
        <Home />
        <About />
        <Skills />
        <Works />
        <ContactMe />
      </main>
    </>
  );
}

export default Main;
